import { PageEvent } from '@angular/material/paginator';
import { Pagination } from 'src/app/models/pagination.model';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BusinessUser } from 'src/app/models/business-user.model';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { MgService } from 'src/app/services/mg.service';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit {

  public items: BusinessUser[];
  public displayedColumns: string[] = ['id','name', 'can_see_all', 'mobile', 'email', 'business', 'options'];
  public businessList: BasicRegister[];

  public page: Pagination;
  public pageSize = 0;
  public length = 0;
  public pageSizeOptions: number[] = [20, 35, 50, 100];
  public pageEvent: PageEvent;
  public isLoading: boolean = false;
  public showAll: boolean = false;

  public searchControl = new UntypedFormControl;

  constructor(
    private router: Router,
    public api: MgService,
    private activedRouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.listAllUserPag()
    this.searchControl.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe(
        res => {
          this.listAllUserPag(1, 20, res);
        }
      )
  }

  public get apiService() {
    return this.api;
  }

  public set showAllUsers(value: boolean) {
    this.showAll = value;
    this.listAllUserPag(
      this.pageEvent ? this.pageEvent.pageIndex + 1 : 1,
      this.pageEvent ? this.pageEvent.pageSize : 20,
      this.searchControl.value,
      this.showAll
    );
  }

  public set setPage(page: PageEvent) {
    this.pageEvent = page;
    this.listAllUserPag(
      page.pageIndex + 1,
      page.pageSize,
      this.searchControl.value,
      this.showAll
    );
  }

  public listAllUserPag(
      page: number = 1,
      perPage: number = 20,
      search: string = '',
      showAll: boolean = false
  ): void {
    let params = this.activedRouter.snapshot.params;
    this.isLoading = true;
      if(params.business) {
        this.api.listBusinessUser(params.business)
          .subscribe(
            res => {
              this.page = res;
              this.items = this.page.data;
              this.length = this.page.meta.total
              this.pageSize = this.page.meta.per_page
            }
          );
      } else {
        search = search == null ? '' : search;
        let all = showAll ? 'all' : '';
        this.api.listAllUser(search, page, perPage, all)
        .subscribe(
          res => {
            this.page = res;
            this.items = this.page.data;
            this.length = this.page.meta.total
            this.pageSize = this.page.meta.per_page
          },
          err => {
            console.error(err);
            this.isLoading = false;
          },
          () => this.isLoading = false,
        )
      }
  }

  public goToAddUser(): void {
    this.router.navigate(['/operador/usuarios/adicionar'])
  }

  public editUser(user: BusinessUser){
    this.router.navigateByUrl(`/operador/usuarios/editar/${ user.id }`)
  }

  public removeUser(user: BusinessUser) {
    this.isLoading = true;
    this.api.removeBusinessUser(user.id)
      .subscribe(
        res => {
          this.listAllUserPag(
            this.pageEvent.pageIndex + 1,
            this.pageEvent.pageSize,
            this.searchControl.value
          );
          this.isLoading = false;
        },
        err => {
          console.error(err);
          this.isLoading = false;
        },
      )
  }
}
